import { Component, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { EntidadFinancieraService } from '../../services/entidad-financiera.service';
import { Router, ActivatedRoute } from '@angular/router';
import { EntidadFinancieraEditComponent } from '../entidad-financiera-edit/entidad-financiera-edit.component';
import { TranslateService } from '@ngx-translate/core';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { CellImageFormatterComponent } from '../cell-image-formatter/cell-image-formatter.component';

@Component({
  selector: 'app-entidad-financiera',
  templateUrl: './entidad-financiera.component.html',
  styleUrls: ['./entidad-financiera.component.scss']
})
export class EntidadFinancieraComponent implements OnInit {

  public translate: TranslateService;
  private gridApi;
  public columnDefs: any[];
  public rowData: any;
  dialogConfig: MatDialogConfig;

  createColumnDef() {
    const columnDefs = [
      {
        headerName: "Eliminar", field: 'id', suppressFilter: true, suppressSorting: true,
        template:
          `
            <a data-action-type="remove">Borrar</a>`,
        pinned: 'left',
        width: 90
      },
      { headerName: this.translate.instant('entidadFinanciera.ag_id'), field: 'id', cellClass: 'grid-opendialog', minWidth: 150 },
      { headerName: this.translate.instant('entidadFinanciera.ag_activo'), field: 'activo', minWidth: 150, cellRendererFramework: CellImageFormatterComponent, cellRendererParams: { modo: "isActivo" } },
      { headerName: this.translate.instant('entidadFinanciera.ag_codEntidad'), field: 'codigoEntidad', minWidth: 150 },
      { headerName: this.translate.instant('entidadFinanciera.ag_nombre'), field: 'nombre', cellClass: 'grid-opendialog', minWidth: 150 },
      { headerName: this.translate.instant('entidadFinanciera.ag_grupoBancario'), field: 'grupoBancario', minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdDate'), field: 'createdDate', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdByName'), field: 'createdByName', minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedDate'), field: 'updatedDate', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedByName'), field: 'updatedByName', minWidth: 150 },

    ];

    return columnDefs;
  }

  constructor(private _EntidadService: EntidadFinancieraService, private _router: Router, private _route: ActivatedRoute, private _dialog: MatDialog, _translateService: TranslateService) {
    this.translate = _translateService;
    this.columnDefs = this.createColumnDef();
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;
  }

  public defaultColDef = {
    // set every column width
    width: 100,
    // make every column editable
    // make every column use 'text' filter by default
    filter: 'agTextColumnFilter'
  };

  ngOnInit() {
    this.getData();
  }

  getData() {
    this._EntidadService.getEntidades().subscribe(data => { this.rowData = data }), err => console.error("Error al recuperar datos de entidades");

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  private hasSelectedRow(): boolean {
    console.log(this.gridApi.getSelectedNodes().length);


    return (this.gridApi.getSelectedNodes().length == 1);
  }

  public newItem() {

    let ref = this._dialog.open(EntidadFinancieraEditComponent, this.dialogConfig);
    ref.componentInstance.isModal = true;
    ref.afterClosed().subscribe(result => {
      this._EntidadService.getEntidades().subscribe(data => { this.rowData = data }), err => console.error("Error al recuperar datos de entidades");
    });
  }

  public onCellClickedEvent($event) {

    if ($event.event.target !== undefined) {
      let data = $event.data;
      let actionType = $event.event.target.getAttribute("data-action-type");

      switch (actionType) {
        case "remove":
          return this.onActionRemoveClick(data);

      }
    }

    if ($event.colDef.cellClass !== undefined && $event.colDef.cellClass.indexOf("grid-opendialog") >= 0) {

      let dlgRef = this._dialog.open(EntidadFinancieraEditComponent, this.dialogConfig);
      dlgRef.componentInstance.id = $event.data.id;
      dlgRef.componentInstance.isModal = true;
      dlgRef.afterClosed().subscribe(result => {
        this._EntidadService.getEntidades().subscribe(data => { this.rowData = data }), err => console.error("Error al recuperar datos de entidades");

      });
    }
  }

  onActionRemoveClick(data: any) {
    var ans = confirm("Quieres eliminar el registro con Id: " + data.id);
    if (ans) {
      this._EntidadService.deleteEntidad(data.id).subscribe((data: any) => {
        if (data.estado == "Error") {
          alert("Esta entidad está asociado a alguna tasación, por lo que no se puede borrar. Si lo desea puede marcarla como inactiva.");
        }
        this.getData();
      });
    }
  }
}
